import { MessageHeader, RequestID, WebSocketCloseUnauthorized } from '@/api/spec.ts';

export type WSEventCategory = 'success' | 'error' | 'unauthorized' | 'retry';

export type WebSocketStatus = 'CONNECTING' | 'OPEN' | 'CLOSING' | 'CLOSED' | 'ERROR';

export type MessageHandler = (message: MessageHeader) => void;

export interface CommonWebSocketReturn {
  status: WebSocketStatus;
  sendMessage: <T extends MessageHeader>(message: T) => RequestID | undefined;
  retryCount: number;
}

export const WS_ENDPOINTS = {
  TRADING: '/ws/v1/trading',
  MARKET_DATA: '/ws/v1/market-data',
} as const;

export const CodeToCategory: Record<number, WSEventCategory> = {
  1000: 'success',
  1001: 'retry',
  1002: 'retry',
  1005: 'retry',
  1006: 'retry',
  1008: 'retry',
  1010: 'error',
  1011: 'retry',
  1012: 'retry',
  1013: 'retry',
  1014: 'error',
  1015: 'error',
  [WebSocketCloseUnauthorized]: 'unauthorized',
};
